import React from 'react';

export const SearchResultRowTitle = (props: { title: string }) => (
  <span>{props.title}</span>
);
